import type { Listable } from '@zcode/state-type'

/**
 * Returns array of listing attributes associated with selectedListingIds.
 *
 * @param listingAttr
 * @param listings
 * @returns  attributes Array of listing attributes associated with selectedListingIds.
 */
const getMessagedListingAttrs = <Key extends keyof Listable>(
  listingAttr: Key,
  listings: readonly Listable[]
): Array<Listable[Key]> => {
  return listings.filter((l) => l.multiMessageSelected).map((l) => l[listingAttr])
}

export default getMessagedListingAttrs
